module.exports = __webpack_public_path__ + "img/3 - 4 - 1 - 2.1d4b0abd.jpg";